<template>
  <div>

    <h3>Sales {{commission_data.month_text}} ${{commission_data.total}} (Testing)</h3>

    <div class="month-selector">
      <select
          v-model="monthindex"
          @change="onMonthChange"
          class="form-select"
      >
        <option
            v-for="month in commission_data.months"
            :key="month.index"
            :value="month.index"
        >
          {{ month.name }}
        </option>
      </select>
    </div>


    <div class="container">
      <table class="table table-striped table-bordered table-hover table-condensed align_left">
        <thead>
        <tr>
          <th>Order Date</th>
          <th>Invoice#</th>
          <th>Store</th>
          <th>Store ID</th>
          <th>$ Amount</th>
        </tr>
        </thead>
        <tbody class="align_left">
        <tr v-for="order in commission_data.list" v-bind:key="order.order_short_id">
          <td>
            {{order.dateformatted}}
          </td>
          <td>
            {{order.order_short_id}}
          </td>
          <td>
            {{order.customer_display_name}}
          </td>
          <td>
            {{order.customer_id}}
          </td>
          <td>
            {{order.total_amount}}
          </td>

        </tr>
        </tbody>
      </table>

    </div>

    </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      monthindex: 0,
      months: [],
    }
  },
  computed: {
    ...mapGetters({
      commission_data: 'admin/commission_data',
      commission_data_loading: 'admin/commission_data_loading',
    }),
  },
  mounted() {
    this.get_commission_data();
  },
  watch:  {
  },
  methods: {
    onMonthChange() {
      if (this.monthindex !== '') {
        this.$store.dispatch('admin/getCommissionData', {monthindex: this.monthindex})
      }
    },
    get_commission_data () {
      this.$store.dispatch('admin/getCommissionData', {monthindex: this.monthindex})
    },
  }
}
</script>

<style scoped>

.month-selector {
  max-width: 180px;
  margin: 1rem 0;
  margin-left: 100px;
}

.form-select {
  padding: 8px 12px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  width: 100%;
}

.align_left {
  text-align: left;
}

</style>
